// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { PhoneNumberPromptDaten, type Prompt } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type CreateIcpFallbackPromptQuery = { activate?: boolean };

export function useCreateIcpFallbackPrompt(): (
  phoneNumberId: string,
  query: CreateIcpFallbackPromptQuery,
  requestBody: PhoneNumberPromptDaten
) => Promise<Prompt> {
  const getAPI = useGetApi();
  return useCallback(
    async (phoneNumberId, query = {}, requestBody) =>
      (await getAPI()).phonenumbers.createIcpFallbackPrompt({
        phoneNumberId,
        ...query,
        requestBody,
      }),
    [getAPI]
  );
}
